module.exports = __webpack_public_path__ + "media/vegetable-with-flut-and-flora.ae11dfd1.mp4";